import { useQuery } from '@tanstack/react-query';
import { OTPApi } from '../../../apis/OTPApi/OTPApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { IOTP } from '../OTP';

export function useOTPsByPatientId(patientId: number | undefined) {
    return useQuery<IOTP[]>({
        queryKey: [QueryKeys.otpByPatient, patientId],
        queryFn: () => OTPApi.getOTPsByPatientId(patientId!),
        enabled: !!patientId,
    });
}
